import React, { memo, useCallback, useMemo, useState } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch } from "antd";
import {
  useGetAdminGetAllChannelsList,
  useGetAdminUsersList,
  useGetAuthorityFindRoles,
  usePostAuthorityAddNewAccess,
} from "core";

const FIRSTENTITY = "firstEntity";
const SECONDENTITY = "secondEntity";
const FIRSTUSER = "user1";
const SECONDUSER = "user2";
const FIRSTROLE = "role1";
const SECOANDROLE = "role2";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const CreateMandantoryMembership = memo(() => {
  const { i18n } = useTranslation();
  const { data: usersData,isFetching:userFetch} = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "2000",
  });
  const { data: rolesData} = useGetAuthorityFindRoles({pageNumber:'1',pageSize:'2000'});
  const { data: channelsData} = useGetAdminGetAllChannelsList({pageNumber:'1',pageSize:'2000'});
  
  const methods = useForm({
    defaultValues: {
      firstEntity: "",
      secondEntity: "",
      user1: "",
      role1: "",
      user2: "",
      role2: "",
      authorities:[]
    },
  });

  const { handleSubmit, reset, watch } = methods;
  const _firstEntity = watch("firstEntity");
  const _secondEntity=watch("secondEntity")
  const { mutate, isPending } = usePostAuthorityAddNewAccess({
    onSuccess: () => {
      reset();
    },
  });

  const onSubmit = useCallback(
    ({
      user1,
      role1,
      user2,
      role2,
      authorities,
    }: {
      user1: string;
      role1: string;
      user2: string;
      role2: string;
      authorities:any
    }) => {
      mutate({
        requestBody: {
          user1,
          role1,
          user2,
          role2,
          authorities
        },
      });
    },
    []
  );

  const usersItem = useMemo((): any[] => {
    return usersData?.data?.users.map((item: any) => {
      return {
        value: item.id,
        label: item?.userName,
      };
    });
  }, [usersData]);

  const rolesItem = useMemo((): any[] => {
    return rolesData?.data.map((item: any) => {
      return {
        value: item.id,
        label: item?.name,
      };
    });
  }, [rolesData]);

  const channelsItem = useMemo((): any[] => {
    return channelsData?.data?.conversations?.map((item: any) => {
      return {
        value: item.id,
        label: item?.title,
      };
    });
  }, [channelsData]);



  const firstEntityItem = [
    { label: i18n.t("user"), value: "user" },
    { label: i18n.t("role"), value: "role" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });

  const secoandEntityItem = [
    { label: i18n.t("user"), value: "user" },
    { label: i18n.t("role"), value: "role" },
    { label: i18n.t("channel"), value: "channel" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });

  return (
    <>
      <Card title={i18n.t("createMandantoryMembership")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller name={FIRSTENTITY}>
                <SelectBox
                  placeholder={i18n.t("firstEntity")}
                  label={i18n.t("firstEntity")}
                  options={firstEntityItem}
                />
              </Controller>
            </Form.Item>

            {_firstEntity === "user" && (
              <Form.Item>
                <Controller name={FIRSTUSER}>
                  <SelectBox
                    // disabled={!Boolean(firstEntity)}
                    placeholder={i18n.t("firstUser")}
                    label={i18n.t("firstUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            )}

            {_firstEntity === "role" && (
              <Form.Item>
                <Controller name={FIRSTROLE}>
                  <SelectBox
                    placeholder={i18n.t("firstRole")}
                    label={i18n.t("firstRole")}
                    options={rolesItem}
                  />
                </Controller>
              </Form.Item>
            )}

            <Form.Item>
              <Controller name={SECONDENTITY}>
                <SelectBox
                  placeholder={i18n.t("SecondEntity")}
                  label={i18n.t("secondEntity")}
                  options={secoandEntityItem}
                />
              </Controller>
            </Form.Item>

            {_secondEntity=== "user" &&
              <Form.Item>
                <Controller name={SECONDUSER}>
                  <SelectBox
                    placeholder={i18n.t("secondUser")}
                    label={i18n.t("secondUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            }
            {_secondEntity === "role" &&
            <Form.Item>
              <Controller name={SECOANDROLE}>
                <SelectBox
                  placeholder={i18n.t("secondRole")}
                  label={i18n.t("secondRole")}
                  options={rolesItem}
                />
              </Controller>
            </Form.Item>}
            {_secondEntity === "channel" &&
            <Form.Item>
              <Controller name={SECOANDROLE}>
                <SelectBox
                  placeholder={i18n.t("secondRole")}
                  label={i18n.t("secondRole")}
                  options={channelsItem}
                />
              </Controller>
            </Form.Item>}

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { CreateMandantoryMembership };
